<script setup lang="ts">
import { nextTick, ref, watch } from "vue";
import { locale } from "../../locale";
import { Instance, createPopper } from "@popperjs/core";
import useHover from "../../composables/useHover";

const props = defineProps<{
  resetAnother: () => void;
}>();

const btn = ref<HTMLElement | null>(null);
const tooltip = ref<HTMLElement | null>(null);
const state = ref(false);
let popper: Instance | null = null;
const reset = () => {
  popper?.destroy();
  state.value = false;
};
const clicked = ref(false);
const hovered = ref(false)
const uh = useHover(btn, (hov) => {
  if (hov) {
    setTimeout(() => {
      if (uh.state.value) {
        hovered.value = true
      }
    }, 1000);
  } else {
    hovered.value = false
  }
});
function showMessage() {
  if (!state.value) {
    state.value = true;
    nextTick(() => {
      popper = createPopper(
        btn.value as HTMLElement,
        tooltip.value as HTMLElement,
        {
          placement: "bottom",
          strategy: "fixed",
          modifiers: [{ name: "offset", options: { offset: [0, 5] } }],
        },
      );
    });
  }
}
function hideMessage() {
    popper?.destroy();
    state.value = false;
}
watch(() => clicked.value || hovered.value, (next) => {
  if(next) showMessage()
  else hideMessage()
})
let lastTimeout: any;
const viewMessage = () => {
  if(lastTimeout) {
    clearTimeout(lastTimeout)
  }
  props.resetAnother();
  clicked.value = true;
  lastTimeout = setTimeout(() => {
    clicked.value = false
  }, 2000)
};
defineExpose({
  reset,
});
</script>
<template>
  <div class="wrapper">
    <svg
      @click="viewMessage"
      ref="btn"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 6.5L5.5 6.5C3.567 6.5 2 8.067 2 10V10C2 11.933 3.567 13.5 5.5 13.5H7.5M12.5 6.5L14.5 6.5C16.433 6.5 18 8.067 18 10V10C18 11.933 16.433 13.5 14.5 13.5H12.5M6 10H14"
        stroke="#747474"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <div v-if="state" class="tooltip" ref="tooltip">
      {{ clicked ? locale.linkcopied : locale.linkcopy }}
    </div>
  </div>
</template>
<style scoped>
svg {
  flex-shrink: 0;
  cursor: pointer;
}

.wrapper {
  display: flex;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.tooltip {
  max-width: 450px;
  overflow-wrap: break-word;
  background-color: rgba(41, 41, 41, 0.85);
  color: #ececec;
  border-radius: 7px;
  padding: 8px 15px;
}
</style>
